import { Injectable } from '@angular/core';

@Injectable()
export class SpinnerService {
    private _isSpinnerVisible: boolean;
    private spinnerMinimumInvisibilityTimeInMs = 600;
    private spinnerVisibilityDelayTimeout: NodeJS.Timeout;

    initialize() {
        clearTimeout(this.spinnerVisibilityDelayTimeout);
        this._isSpinnerVisible = false;
    }

    turnOnSpinner() {
        if (!this._isSpinnerVisible) {
            if (this.spinnerVisibilityDelayTimeout) {
                clearTimeout(this.spinnerVisibilityDelayTimeout);
            }
            this.setSpinnerVisibilityDelayTimeout();
        }
    }

    turnOffSpinner() {
        if (this.spinnerVisibilityDelayTimeout) {
            clearTimeout(this.spinnerVisibilityDelayTimeout);
        }
        this._isSpinnerVisible = false;
    }

    get isSpinnerVisible() {
        return this._isSpinnerVisible;
    }

    private setSpinnerVisibilityDelayTimeout() {
        this.spinnerVisibilityDelayTimeout = setTimeout(() => {
            this._isSpinnerVisible = true;
        }, this.spinnerMinimumInvisibilityTimeInMs);
    }
}
